var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['analysis-stepper', { 'analysis-stepper--invisible': _vm.currentStepIndex === 0 }]},_vm._l((_vm.stepsWithLabel),function(step,i){return _c('div',{key:step.key,class:[
      'analysis-stepper__step',
      {
        'analysis-stepper__step--active': step.key === _vm._currentStepKey,
        'analysis-stepper__step--completed': i <= _vm.currentStepIndex,
        'analysis-stepper__step--disabled': i > _vm.currentStepIndex || _vm.lock,
      } ],on:{"click":function($event){_vm.$pdc.analysis.currentStepKey = step.key}}},[_c('p',[_vm._v(_vm._s(step.label))]),_c('div',{staticClass:"analysis-stepper__step__marker"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }